module.exports = __webpack_public_path__ + "static/media/case_05.5d03ae50.jpg";